import React from "react";

import CheckboxInput from 'pu-react/components/CheckboxInput';

const Title = ({id, name, title, product_url, checked, onChange}) => {

  return (
    <div className="form-check accessory-title-block">
      <CheckboxInput
        id={id}
        name={name}
        groupName=''
        inputClassName='form-check-input'
        checked={checked}
        onChange={onChange}/>
      <label className="form-check-label accessory-title text-uppercase" htmlFor={name}>
        <a href={product_url} target="_blank">
          {title}
        </a>
      </label>
    </div>
  )
}

export default Title;